/* eslint-disable react/no-danger */
import { useEffect } from "react";
import parse from "html-react-parser";
import { transformToHtml } from "../../utils/CommonUtils";

export default function Offers(props) {
  const {
    main_div: mainDiv,
    appData,
    apiUrl,
    devId = "",
    mcid = "",
    ccde,
    state,
    appConfig = {},
    lang,
    device,
    heading_and_searchbar: headingAndSearchBar,
    intid,
    contentTop,
    contentMiddle,
    contentBottom,
    bottomBlock,
    top_overlay: topOverlay,
    initial_js: initialJS,
    tokenJson,
    template_type: templateType,
  } = props?.data || {};
  const isDesktop = device === "desktop";
  const isLive = appConfig.liveMode;
  let srcWidget = "";
  if (isLive) {
    if (isDesktop) {
      srcWidget =
        lang === "hin"
          ? `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidget.min.js`
          : `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidget.min.js`;
    } else {
      srcWidget =
        lang === "hin"
          ? `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidgetMob.min.js`
          : `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidgetMob.min.js`;
    }
  } else if (isDesktop) {
    srcWidget =
      lang === "hin"
        ? "http://localhost:3000/_next/static/js/hiStaticSeoWidget.min.js"
        : "http://localhost:3000/_next/static/js/staticSeoWidget.min.js";
  } else {
    srcWidget =
      lang === "hin"
        ? "http://localhost:3000/_next/static/js/hiStaticSeoWidgetMob.min.js"
        : "http://localhost:3000/_next/static/js/staticSeoWidgetMob.min.js";
  }

  useEffect(() => {
    const bodyElement = document.body;
    bodyElement.id = "cmsintlflt";
    bodyElement.className = "bodyClass";
    bodyElement.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
  }, []);
  const scriptTransform = {
    transform: (node) => {
      if (node.type === "script") {
        return (
          <script defer src={node?.attribs?.src}>
            {node?.children[0]?.data}
          </script>
        );
      }
      return null;
    },
  };
  const stylesDesktop = `.midContainerSpace{
    height: 0 !important;
}
.midContainer {
width: 100%;
padding: 20px 0;
margin-top: -20px;
}
@media screen and (min-width: 768px) {
    .fli-intl-container {
        padding-top: 0;
    }
}
.lockPriceModalWrapper .arrow::after, .arrow::before {
    height: 0px !important;
}
.widgetSprite {
    background-position: -5px -5px !important;
}
.container {
margin-top: 15px;
width: 100%;
}
.modify-search-header{
display: none !important;
}`;
  const stylesMobile = `.modify-search-header {
    position: relative !important;
    font-family: Lato-Regular,Arial,Helvetica,sans-serif !important;
}
.midContainer {
    padding: 0 !important;
    margin-top: -10px !important;
}
.widgetSprite {
    background-position: -5px -5px !important;
}
.lndngFltPrgsvWrap--hdr span h1 {
    font-size: 25px !important;
}
.srchForm {
    box-shadow: none;
}
.container {
margin-top: 15px;
/* width: 100%; */
}`;
  tokenJson.currentTemplate = templateType;
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          window.FLTS = {};
          window.FLTS.listingStartTime = Date.now();
          window.page = "offers";
          window.countryCode = '${ccde}';
          window.lang = '${lang}';
          window.url ='${apiUrl}';
          window.devId = "${devId || ""}";
          window.mcid = "${mcid || ""}";
          window.appData = ${JSON.stringify(appData)};`,
        }}
        type="text/javascript"
      />
      {initialJS && initialJS !== "" ? parse(initialJS) : null}
      {isDesktop ? (
        <style dangerouslySetInnerHTML={{ __html: stylesDesktop }} />
      ) : (
        <style dangerouslySetInnerHTML={{ __html: stylesMobile }} />
      )}
      {isDesktop ? (
        <header className="newSection modify-search-header" id="orderHeader">
          {transformToHtml(headingAndSearchBar)}
        </header>
      ) : (
        // <header className="modify-search-header" id="orderHeader">
        //   { transformToHtml(headingAndSearchBar) }
        // </header>
        <header
          dangerouslySetInnerHTML={{ __html: headingAndSearchBar }}
          className="modify-search-header"
          id="orderHeader"
        />
      )}
      {/* <script dangerouslySetInnerHTML={{ __html: script }} type="text/javascript" /> */}
      <section className="midContainer">
        {transformToHtml(contentTop)}
        <div dangerouslySetInnerHTML={{ __html: mainDiv }} />
        {transformToHtml(contentMiddle)}
        {contentBottom && bottomBlock && bottomBlock.length > 0 && contentBottom.length > 0 ? (
          <div className="container offersWrapper">
            {transformToHtml(contentBottom)}
            {transformToHtml(bottomBlock)}
          </div>
        ) : (
          <></>
        )}
      </section>
      {transformToHtml(topOverlay)}
      <script dangerouslySetInnerHTML={{ __html: "window.showLeaveIntent = true;" }} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
      var tokenJson = ${
        tokenJson
          ? JSON.stringify(tokenJson)
          : '{"dest_city_name":"Mumbai","src_city_code":"DEL","dest_city_code":"BOM","src_city_name":"New Delhi"};'
      }
      var intid = "${intid}";
      var mmt = window.mmt || {};
      mmt.hlp = mmt.hlp || {};
      var device = "${device}";
      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = ${JSON.stringify(
        new Date(),
      )}, serverTime = ${JSON.stringify(new Date())}, noOfDaysToAddInDept = ${
            tokenJson?.noOfDaysToAddInDept || ""
          }, noOfDaysToAddInReturn = ${tokenJson?.noOfDaysToAddInReturn || ""}
      `,
        }}
        type="text/javascript"
      />
      <div className="overlay_hamburger" />
      <a id="back-top" className="back-to-top">
        &#160;
      </a>
      {/* <div id="seo-bottom" class="seo">
        <div id="footer_block">
          { transformToHtml(footer) }
        </div>
        <input name="domain_id" id="domain_id" type="hidden" value="www_intl_flight_makemytrip_com" />
      </div> */}
      <script defer type="text/javascript" src={`${srcWidget}`} />
    </>
  );
}
